import { render, staticRenderFns } from "./CreateProcedure.vue?vue&type=template&id=070f1a73&scoped=true&"
import script from "./CreateProcedure.vue?vue&type=script&lang=js&"
export * from "./CreateProcedure.vue?vue&type=script&lang=js&"
import style0 from "./CreateProcedure.vue?vue&type=style&index=0&id=070f1a73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f1a73",
  null
  
)

export default component.exports